__turbopack_context__.v({
  "internal_navigation": "ModalPageTransition-module-scss-module__6oXdwq__internal_navigation",
  "modal_page_transition": "ModalPageTransition-module-scss-module__6oXdwq__modal_page_transition",
});
